import { FiCircle } from 'react-icons/fi';
import { MdOutlineArticle, MdSummarize } from 'react-icons/md';

const resportsNavigation = [
    {
        id: 'reports',
        title: 'Reports',
        type: 'collapse',
        icon: <MdSummarize size={20} />,
        children: [
            {
                id: 'reports_table_list',
                title: 'Table List',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/reports/table_list',
                action: 'read',
                resource: 'table_list_reports',
            },
            {
                id: 'stats_reports',
                title: 'Stats Reports',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/reports/stats_reports',
                action: 'read',
                resource: 'stats_reports',
            },
            {
                id: 'reports_referral',
                title: 'Referral Reports',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/reports/referral_reports',
                action: 'read',
                resource: 'referral_reports',
            },
            {
                id: 'reports_lawyer',
                title: 'Lawyer Reports',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/reports/lawyer_reports',
                action: 'read',
                resource: 'lawyer_reports',
            },
            {
                id: 'reports_elc',
                title: 'ELC',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/reports/elc_reports',
                action: 'read',
                resource: 'elc_reports',
            },
        ],
    },
    {
        id: 'apb_reports',
        title: 'APB Reports',
        icon: <MdOutlineArticle size={20} />,
        navLink: '/apb_reports',
        action: 'read',
        resource: 'apb_reports',
    },
];
export default resportsNavigation;
